import { AdminLayout } from '@/components/Layout';
import { usePagination } from '@/hooks/usePagination';
import ContractList from '../../components/ContractList';

export const SignedContract = () => {
  const { page, changePage } = usePagination();

  return (
    <AdminLayout title="">
      <ContractList page={page} changePage={changePage} />
    </AdminLayout>
  );
};
